export const i18n = {
  messages: {
    "en-US": {
      "page": {
        "title": "Location Management",
        "subtitle": "Manage locations for stores, warehouses, and vendors."
      },
      "template": {
        "buttons": {
          "batch-edit": { "label": "Batch Edit Mode" },
          "create-location": { "label": "Add New Location" },
          "add-custom-opening-times": { "label": "Add Custom Opening Times" },
        },
        "filters": {
          "title": "Filter",
          "filter": {
            "label": {
              "name": "Name",
              "type": "Type",
              "active": "Active"
            },
            "options": {
              "active": {
                "yes": "Yes",
                "no": "No",
              },
              "type": {
                "store": "Store",
                "warehouse": "Warehouse",
                "dc": "Distribution Center",
                "vendor": "Supplier",
              }
            }
          }
        },
        "results": {
          "title": "Results",
          "no-results": "No Results Found",
          "table": {
            "header": {
              "id": "No.",
              "name": "Name",
              "type": "Type",
              "active": "Active?",
              "actions": "Actions"
            },
            "body": {
              "edit-contact-info": "Edit Contact Information",
              "edit-service-times": "Edit Service Times",
              "edit-service-settings": "Edit Service Settings",
              "edit-properties": "Edit Properties",
              "active": {
                "yes": "Yes",
                "no": "No",
              }
            },
          },
        },
      }
    },
    "nl-NL": {
      "page": {
        "title": "Locatiebeheer",
        "subtitle": "Beheer locaties van winkels, magazijnen en leveranciers."
      },
      "template": {
        "buttons": {
          "batch-edit": { "label": "Batch Bewerkingsmodus" },
          "create-location": { "label": "Nieuwe locatie toevoegen" },
          "add-custom-opening-times": { "label": "Aangepaste openingstijden toevoegen" },
        },
        "filters": {
          "title": "Filter",
          "filter": {
            "label": {
              "name": "Naam",
              "type": "Type",
              "active": "Actief"
            },
            "options": {
              "active": {
                "yes": "Ja",
                "no": "Nee",
              },
              "type": {
                "store": "Winkel",
                "warehouse": "Magazijn",
                "dc": "Distributiecentrum",
                "vendor": "Leverancier",
              }
            }
          }
        },
        "results": {
          "title": "Resultaten",
          "no-results": "Geen resultaten gevonden",
          "table": {
            "header": {
              "id": "Nr.",
              "name": "Naam",
              "type": "Type",
              "active": "Actief?",
              "actions": "Acties"
            },
            "body": {
              "edit-contact-info": "Contactinformatie bewerken",
              "edit-service-times": "Servicetijden bewerken",
              "edit-service-settings": "Service-instellingen bewerken",
              "edit-properties": "Eigenschappen bewerken",
              "active": {
                "yes": "Ja",
                "no": "Nee",
              }
            },
          },
        },
        "batch-opening-times": {
          "loading": "Bezig met laden...",
          "title": "Voeg aangepaste openingstijden toe",
          "close-button": "Popup sluiten",
          "locations-title": "Aan locaties:",
          "active": "Actief",
          "inactive": "Inactief",
          "service-type": "Service-type:",
          "overwrite-conflicts": "Overschrijf conflicterende service-tijden",
          "add-service-time-title": "Nieuwe service-tijden toevoegen:",
          "add-service-time-tooltip-valid": "Klik om toe te voegen aan alle geselecteerde locaties",
          "add-service-time-tooltip-invalid": "Nog niet alle verplichte velden ingevuld",
          "watch-out": "Let op:",
          "location-overwrite-state-on-prefix": "Als een locatie al service-tijden heeft voor de datum wordt deze",
          "location-overwrite-state-off-prefix": "Als een locatie al service-tijden heeft voor de datum blijft deze",
          "location-overwrite-state-on": "overschreven",
          "location-overwrite-state-off": "ongewijzigd",
          "service-time-added": "Service-tijden toegevoegd:",
          "date": "Datum",
          "status": "Status",
          "from": "Van",
          "to": "Tot",
          "cutoff": "Cutoff",
          "description": "Omschrijving",
          "save": "Opslaan",
          "add-another": "Nog één toevoegen",
          "count-added": "Aantal succesvol toegevoegd:",
          "count-ignored": "Locaties niet geüpdatet:",
          "list-errors": "Sommige locaties zijn niet goed geüpdatet:",
          "message-updated-none": "Geen enkele locatie is aangepast, omdat er alleen conflicterende service-tijden zijn.",
        }
      }
    },
  }
};

export default i18n;
